import React, {useState, ChangeEvent, useRef} from 'react';

interface CheckboxAndCommentProps {
    checkboxText: string;
    checked: boolean;
    comment: string;
    hideCommentOnlyOnValues?: boolean;
    onValueChange?: (comment: string, checked: boolean) => void;
    isDisabled?: boolean;
}

const CheckboxAndComment: React.FC<CheckboxAndCommentProps> = ({ checkboxText, checked, comment, hideCommentOnlyOnValues, onValueChange, isDisabled }) => {
    const [checkedValue, setCheckedValue] = useState(checked);
    const [commentValue, setCommentValue] = useState(comment);

    const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
        const newChecked = event.target.checked;

        setCheckedValue(newChecked);

        if (newChecked) {
            setCommentValue("");
        }

        if (onValueChange) {
            onValueChange(newChecked ? "" : commentValue, newChecked);
        }
    };

    const handleCommentChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        const newValue = event.target.value;
        setCommentValue(newValue);

        if (newValue.length > 0) {
            setCheckedValue(false);
        }

        if (onValueChange) {
            onValueChange(newValue, newValue.length > 0 ? false : checkedValue);
        }
    };

    return (
        <div className="checkbox-question">
            <div className="checkbox">
                <label>
                    <input disabled={isDisabled || commentValue.length > 0} type="checkbox" checked={checkedValue} onChange={handleCheckboxChange}/>{checkboxText}
                </label>
            </div>
            {(hideCommentOnlyOnValues === undefined || hideCommentOnlyOnValues !== checked) &&
                <textarea value={commentValue} onChange={handleCommentChange} className="form-control"></textarea>
            }
        </div>
    )
}

export default CheckboxAndComment;
